import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import toast from 'react-hot-toast';
import './AuthPages.css';

export default function LoginPage({ navigate }) {
  const { login, loading } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.email) e.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Enter valid email';
    if (!form.password) e.password = 'Password is required';
    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    const res = await login(form.email, form.password);
    if (res.success) {
      toast.success(res.role === 'admin' ? '👑 Welcome, Admin!' : '🎉 Welcome back!');
      navigate(res.role === 'admin' ? 'admin' : 'home');
    } else {
      toast.error(res.error);
      setErrors({ general: res.error });
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-split">
        {/* Left visual */}
        <div className="auth-visual">
          <div className="auth-visual-content">
            <div className="auth-logo" onClick={() => navigate('home')}>🌿 FreshMart</div>
            <h2>Your Daily Groceries,<br/><span>Delivered Fresh</span></h2>
            <p>Shop from 200+ fresh products — fruits, veggies, dairy & more. Delivered to your door in 30 minutes.</p>
            <div className="auth-features">
              {['🚀 30-min Express Delivery', '🌿 100% Organic Products', '📍 Real-time Order Tracking', '💰 Best Price Guarantee'].map(f => (
                <div className="auth-feat" key={f}>{f}</div>
              ))}
            </div>
            <div className="auth-visual-imgs">
              <img src="https://images.unsplash.com/photo-1542838132-92c53300491e?w=300&q=80" alt="groceries" />
              <img src="https://images.unsplash.com/photo-1619566636858-adf3ef46400b?w=300&q=80" alt="fruits" />
              <img src="https://images.unsplash.com/photo-1540420773420-3366772f4999?w=300&q=80" alt="vegetables" />
            </div>
          </div>
        </div>

        {/* Right form */}
        <div className="auth-form-side">
          <div className="auth-form-wrap">
            <div className="auth-form-header">
              <button className="auth-back" onClick={() => navigate('home')}>← Back to Home</button>
              <h1>Welcome Back 👋</h1>
              <p>Sign in to your FreshMart account</p>
            </div>

            {/* Demo credentials hint */}
            <div className="demo-hint">
              <span>🔑</span>
              <div>
                <strong>Demo Admin:</strong> admin@freshmart.com / admin123
              </div>
            </div>

            <form onSubmit={handleSubmit} className="auth-form">
              <div className={`input-group ${errors.email ? 'error' : ''}`}>
                <label>Email Address</label>
                <div className="input-wrap">
                  <span className="input-icon">✉️</span>
                  <input
                    type="email"
                    placeholder="you@example.com"
                    value={form.email}
                    onChange={e => { setForm(f => ({ ...f, email: e.target.value })); setErrors({}); }}
                    autoComplete="email"
                  />
                </div>
                {errors.email && <span className="err-msg">{errors.email}</span>}
              </div>

              <div className={`input-group ${errors.password ? 'error' : ''}`}>
                <label>Password</label>
                <div className="input-wrap">
                  <span className="input-icon">🔒</span>
                  <input
                    type={showPass ? 'text' : 'password'}
                    placeholder="Enter your password"
                    value={form.password}
                    onChange={e => { setForm(f => ({ ...f, password: e.target.value })); setErrors({}); }}
                    autoComplete="current-password"
                  />
                  <button type="button" className="show-pass" onClick={() => setShowPass(!showPass)}>
                    {showPass ? '🙈' : '👁️'}
                  </button>
                </div>
                {errors.password && <span className="err-msg">{errors.password}</span>}
              </div>

              <button type="submit" className="auth-submit-btn" disabled={loading}>
                {loading ? <span className="loading-dots"><span/><span/><span/></span> : '→ Sign In'}
              </button>
            </form>

            <div className="auth-divider"><span>or</span></div>

            <button className="google-btn" onClick={() => toast('Google sign-in coming soon!')}>
              <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" width="20" />
              Continue with Google
            </button>

            <p className="auth-switch">
              Don't have an account?{' '}
              <button onClick={() => navigate('signup')}>Create Account →</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
